import { Expose } from 'class-transformer';

export default class StockCentralFilter {
  @Expose()
  from?: Date;

  @Expose()
  to?: Date;

  @Expose()
  ignoreMyReservations?: boolean;

  @Expose()
  references?: string[];

  @Expose()
  collections?: string[];

  @Expose()
  openAllRegisters?: boolean;

  constructor() {
    this.ignoreMyReservations = false;
    this.references = [];
    this.collections = [];
    this.openAllRegisters = true;
  }
}
